import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import { computed } from "vue";
import store from "../store/tabls";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'tabls1',
  setup(__props) {
    const router = useRouter();
    const editableTabsValue = computed(() => {
      return store.state.editableTabsValue;
    });
    //let editableTabs = ref(store.state.editableTabs)
    let editableTabs = computed(() => {
      return store.state.editableTabs;
    });
    function removeTab(targetName) {
      const tabs = editableTabs.value;
      let activeName = editableTabsValue.value;
      if (targetName === "Index") {
        return;
      }
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      //editableTabsValue.value = activeName;
      store.commit("removeTab", targetName);
      //editableTabs.value = tabs.filter((tab) => tab.name !== targetName);
      router.push(activeName);
    }
    ;
    function clickTab(targetName) {
      router.push(targetName.props.name);
    }
    ;
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(_component_el_tabs, {
        modelValue: editableTabsValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editableTabsValue.value = $event),
        type: "card",
        class: "demo-tabs",
        closable: "",
        onTabRemove: removeTab,
        onTabClick: clickTab
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.title,
            name: item.name
          }, null, 8, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});